var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLexiconsNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_544_2304",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_544_2304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.86537 21.4998C6.21794 21.4998 5.66186 21.2824 5.19712 20.8478C4.73237 20.4132 4.5 19.8754 4.5 19.2344V5.58248C4.5 5.00685 4.68622 4.49627 5.05867 4.05076C5.43111 3.60526 5.90514 3.32225 6.48077 3.20173L15.8077 1.2998V16.6075L6.64037 18.5171C6.46472 18.5568 6.31408 18.6424 6.18845 18.7738C6.0628 18.9052 5.99997 19.0587 5.99997 19.2344C5.99997 19.4562 6.08619 19.6392 6.25862 19.7834C6.43107 19.9277 6.63332 19.9998 6.86537 19.9998H18V4.4998H19.5V21.4998H6.86537ZM8.69225 16.5787L14.3077 15.4113V3.144L8.69225 4.29211V16.5787ZM7.1923 16.8825V4.59593L6.78845 4.68056C6.56023 4.72671 6.37177 4.83151 6.22305 4.99498C6.07433 5.15845 5.99997 5.35428 5.99997 5.58248V17.2287C6.10254 17.1761 6.20767 17.1309 6.31537 17.0931C6.42306 17.0553 6.53139 17.0248 6.64037 17.0017L7.1923 16.8825Z",
    fill: "#454545"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLexiconsNav);
export default __webpack_public_path__ + "static/media/lexicons-nav.3552c086726f7edb33111db86ea16db7.svg";
export { ForwardRef as ReactComponent };